__turbopack_context__.v({
  "baseLayoutGrid": "styles-module__HSNEuG__baseLayoutGrid",
  "bgRewardSpecial": "styles-module__HSNEuG__bgRewardSpecial",
  "bgYellow": "styles-module__HSNEuG__bgYellow",
  "bubbleWording": "styles-module__HSNEuG__bubbleWording",
  "cardResultBadge": "styles-module__HSNEuG__cardResultBadge",
  "conditionHeader": "styles-module__HSNEuG__conditionHeader",
  "couponGrid": "styles-module__HSNEuG__couponGrid",
  "couponGridWithQr": "styles-module__HSNEuG__couponGridWithQr",
  "couponHeader": "styles-module__HSNEuG__couponHeader",
  "couponHeaderRow": "styles-module__HSNEuG__couponHeaderRow",
  "couponPanel": "styles-module__HSNEuG__couponPanel",
  "couponQr": "styles-module__HSNEuG__couponQr",
  "discountTicket": "styles-module__HSNEuG__discountTicket",
  "downloadCard": "styles-module__HSNEuG__downloadCard",
  "downloadTemplate": "styles-module__HSNEuG__downloadTemplate",
  "downloadTemplateFooter": "styles-module__HSNEuG__downloadTemplateFooter",
  "flareImage": "styles-module__HSNEuG__flareImage",
  "giftBox": "styles-module__HSNEuG__giftBox",
  "headerOverlayDiamond": "styles-module__HSNEuG__headerOverlayDiamond",
  "headerOverlayGold": "styles-module__HSNEuG__headerOverlayGold",
  "headerOverlayNoTier": "styles-module__HSNEuG__headerOverlayNoTier",
  "headerOverlayPlatinum": "styles-module__HSNEuG__headerOverlayPlatinum",
  "headerOverlaySilver": "styles-module__HSNEuG__headerOverlaySilver",
  "listOlPrefix": "styles-module__HSNEuG__listOlPrefix",
  "luckyDrawPageHeight": "styles-module__HSNEuG__luckyDrawPageHeight",
  "luckyDrawPageHeightIsLine": "styles-module__HSNEuG__luckyDrawPageHeightIsLine",
  "mascotImage": "styles-module__HSNEuG__mascotImage",
  "maxHNone": "styles-module__HSNEuG__maxHNone",
  "natural-intense-shake": "styles-module__HSNEuG__natural-intense-shake",
  "oc": "styles-module__HSNEuG__oc",
  "priceTicketText": "styles-module__HSNEuG__priceTicketText",
  "revealCardAnchor": "styles-module__HSNEuG__revealCardAnchor",
  "revealConfetti": "styles-module__HSNEuG__revealConfetti",
  "revealCoupon": "styles-module__HSNEuG__revealCoupon",
  "revealFlare": "styles-module__HSNEuG__revealFlare",
  "revealFootnote": "styles-module__HSNEuG__revealFootnote",
  "revealSharerName": "styles-module__HSNEuG__revealSharerName",
  "revealStage": "styles-module__HSNEuG__revealStage",
  "revealTitle": "styles-module__HSNEuG__revealTitle",
  "revealWordmark": "styles-module__HSNEuG__revealWordmark",
  "rewardCoupon": "styles-module__HSNEuG__rewardCoupon",
  "scrollableContainer": "styles-module__HSNEuG__scrollableContainer",
  "shakeAnimation": "styles-module__HSNEuG__shakeAnimation",
  "special": "styles-module__HSNEuG__special",
  "spinAmount": "styles-module__HSNEuG__spinAmount",
  "spinBgShade": "styles-module__HSNEuG__spinBgShade",
  "spinBlower": "styles-module__HSNEuG__spinBlower",
  "spinBreeze": "styles-module__HSNEuG__spinBreeze",
  "spinBreezeGlow": "styles-module__HSNEuG__spinBreezeGlow",
  "spinColumn": "styles-module__HSNEuG__spinColumn",
  "spinConfetti": "styles-module__HSNEuG__spinConfetti",
  "spinCta": "styles-module__HSNEuG__spinCta",
  "spinEffect": "styles-module__HSNEuG__spinEffect",
  "spinFire": "styles-module__HSNEuG__spinFire",
  "spinFireLeft": "styles-module__HSNEuG__spinFireLeft",
  "spinFireRight": "styles-module__HSNEuG__spinFireRight",
  "spinFlare": "styles-module__HSNEuG__spinFlare",
  "spinHeading": "styles-module__HSNEuG__spinHeading",
  "spinHintIcon": "styles-module__HSNEuG__spinHintIcon",
  "spinHintText": "styles-module__HSNEuG__spinHintText",
  "spinResultCard": "styles-module__HSNEuG__spinResultCard",
  "spinStage": "styles-module__HSNEuG__spinStage",
  "spinStartButton": "styles-module__HSNEuG__spinStartButton",
  "spinStartHint": "styles-module__HSNEuG__spinStartHint",
  "spinTicket": "styles-module__HSNEuG__spinTicket",
  "spinTicketBorder": "styles-module__HSNEuG__spinTicketBorder",
  "summaryBg": "styles-module__HSNEuG__summaryBg",
  "summaryBgDiamond": "styles-module__HSNEuG__summaryBgDiamond",
  "summaryBgGold": "styles-module__HSNEuG__summaryBgGold",
  "summaryBgNoTier": "styles-module__HSNEuG__summaryBgNoTier",
  "summaryBgPlatinum": "styles-module__HSNEuG__summaryBgPlatinum",
  "summaryBgSilver": "styles-module__HSNEuG__summaryBgSilver",
  "summaryCardWrapper": "styles-module__HSNEuG__summaryCardWrapper",
  "summaryMinHeight": "styles-module__HSNEuG__summaryMinHeight",
  "textDiscountTotal": "styles-module__HSNEuG__textDiscountTotal",
  "textGrayShadow": "styles-module__HSNEuG__textGrayShadow",
  "textReward": "styles-module__HSNEuG__textReward",
  "textSubTitle": "styles-module__HSNEuG__textSubTitle",
  "textTitle": "styles-module__HSNEuG__textTitle",
  "textYellow": "styles-module__HSNEuG__textYellow",
  "ticket": "styles-module__HSNEuG__ticket",
  "ticketCaption": "styles-module__HSNEuG__ticketCaption",
  "ticketLogo": "styles-module__HSNEuG__ticketLogo",
  "ticketPanel": "styles-module__HSNEuG__ticketPanel",
  "ticketTitle": "styles-module__HSNEuG__ticketTitle",
  "ticketUnit": "styles-module__HSNEuG__ticketUnit",
  "xlBaseLayoutMinHeight": "styles-module__HSNEuG__xlBaseLayoutMinHeight",
  "xlBaseLayoutMinHeightStickTop": "styles-module__HSNEuG__xlBaseLayoutMinHeightStickTop",
});
